import { VFC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormDatepickerField } from "../../../../../../shared/components/form/fields/form-datepicker.field";
import { FormField } from "../../../../../../shared/components/form/form-field.component";
import { ICfmResponseValueFormInputs } from "../../actions/order-x-action.component";

export const OrderXLogisticPerformedBulkAction: VFC = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext<ICfmResponseValueFormInputs>();
  const { t } = useTranslation();

  return (
    <FormField md={12} className={"pb-4"}>
      <FormDatepickerField
        label={t(`orders.accept_form.actual_pickup_date.label`)}
        hasError={Boolean(errors?.logisticPerformed?.actualPickupDate)}
        control={control}
        required={true}
        name={`logisticPerformed.actualPickupDate`}
      />
    </FormField>
  );
};
